<template>
  <div class="userEdit">
    <van-address-edit
      :area-list="areaList"
      show-set-default
      show-delete
      :search-result="searchResult"
      @save="onSave"
      @delete="onDelete"
      class="container"
      :tel-validator="validator"
      detail-maxlength="100"
      :is-saving="isSaving"
      :address-info="addressInfo"
    />
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { AddressEdit, Toast, Notify, Overlay, Dialog } from "vant";
import AreaList from "../../config/area";
import service from "../../api/user/address";
import loading from "../../components/loading/loading";
export default {
  components: {
    [AddressEdit.name]: AddressEdit,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    loading
  },
  data() {
    return {
      isLoading: true, //loading状态
      areaList: AreaList,
      searchResult: [],
      isSaving: false,
      addressInfo: {},
      type: "update"
    };
  },
  methods: {
    validator(e) {
      // let myreg1 = /^[1][3,4,5,7,8][0-9]{9}$/;
      let myreg2 = /^[0-9]\d{10}$/;
      if (!myreg2.test(e)) {
         Notify({
          type: "danger",
          message: "手机格式不正确"
        });
        return false;
      }else{
        console.log('手机号正确')
        return true
      }
    },
    onSave(e) {
      console.log(e,'添加地址')
      this.isSaving = false;
      this.isLoading = true;
       // 姓名长度改为50
      if (e.name.length > 50) {
        Notify({
          type: "danger",
          message: "姓名长度不能超过50"
        });
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
        return;
      }

      if (this.type == "update") {
        service
          .updateAddress(e)
          .then(() => {
            this.isSaving = false;
            this.$router.go(-1);
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          })
          .catch((err) => {
            Toast(err);
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
      } else {
        service
          .addAddress(e)
          .then((res) => {
            this.isSaving = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            Toast(err);
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
      }
    },
    onDelete(info) {
      service
        .deleteAddress(info.id)
        .then((res) => {
          if (res.statusCode == 200) {
            Toast("删除成功");
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          Toast(err);
        });
    },
    init() {
      if (this.$route.query.type == "update") {
        service
          .getAddressDetail(this.$route.query.id)
          .then((response) => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
            let tAddressInfo = {};
            tAddressInfo = {
              id: response.data.id,
              name: response.data.name,
              tel: response.data.cellPhone,
              province: response.data.province,
              city: response.data.city,
              county: response.data.district,
              addressDetail: response.data.details,
              isDefault: response.data.isDefault,
              areaCode: response.data.districtCode
            };
            this.addressInfo = tAddressInfo;
            this.type = "update";
          })
          .catch((error) => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
            if (error.status == 404) {
              this.showEmpty = true;
            }
          });
      } else {
        this.type = "add";
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    }
  },

  mounted() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.userEdit{
  .container {
  // position: fixed;
  // height: calc(100% - 18.6vw);
  min-height: 100vh;
  overflow-x: hidden;
  // background: #f7f7f7;
   @{deep}.van-button--default{
    background: #f8f8f8;
    border: 0;
    
  }
  @{deep}.van-button::before{
      background-color:#f8f8f8;
    }
  @{deep}.van-address-edit__fields .van-field .van-field__label {
  width: 60px;
  margin-right: 2.2vw;
  flex: none;
}
.van-address-edit__fields .van-field .van-cell__value {
  text-align: left;
}
  @{deep}.van-cell{
    padding-top: 4vw;
    padding-bottom: 4vw;
  }
  @{deep}.van-address-edit-detail{
    padding: 0;
  }
}
}

</style>